// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"wE-z","smallCardRow":"xE-z","largeCardRow":"yE-z","productSearchRow":"zE-z","curatedRow":"AE-z"};